import React from 'react';

import Footer from './styles';

const FooterBar = ({ children }) => {
	return(
		<Footer>{children}</Footer>
	);
};

export default FooterBar;